export const routes = {
    landing: '/',
    list: '/list'
};
